import { render, staticRenderFns } from "./QuestionWrapper.vue?vue&type=template&id=6a20e456"
import script from "./QuestionWrapper.vue?vue&type=script&lang=js"
export * from "./QuestionWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports